import UserDetailsComponent from "./UserDetails.container";

export default UserDetailsComponent;
